import { render, staticRenderFns } from "./extractResult.vue?vue&type=template&id=7450bbd6&scoped=true&"
import script from "./extractResult.ts?vue&type=script&lang=js&"
export * from "./extractResult.ts?vue&type=script&lang=js&"
import style0 from "./extractResult.less?vue&type=style&index=0&id=7450bbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450bbd6",
  null
  
)

export default component.exports